import React, { Component, Fragment } from 'react';
import { Row, Col, Button, Form } from 'antd';
import cx from 'classnames';
import Translate from 'react-translate-component';
import { path } from 'ramda';
import { Field, FormSpy } from 'react-final-form';
import { asyncConnect } from 'react-async-client';
import translate from 'counterpart';

import {
    METRO_REQUEST_CURRENT,
    METRO_REQUEST_NEW,

    METRO_REQUEST_DRAFT,
    METRO_REQUEST_REJECTED,

    METRO_REQUEST_APPROVALS,
} from 'constants/metro';
import { CODE } from 'constants/regexp';
import { formItemLayout, wrapCellFormItem } from 'constants/formItemLayout';
import { getMetroPosition } from 'actions/asyncActions';
import { openModalMetroRequestPosition } from 'actions/modalActions';
import { getApprover } from 'helpers/metroHelpers';
import { required } from 'utils/validators';
import ErrorHTML from 'components/common/form/ErrorHTML';
import ListenerField from 'components/common/form/ListenerField';
import ApprovalButtons from 'components/common/controls/approvals/ApprovalButtons';
import ApprovalRouteList from 'components/views/metro/ApprovalRouteList';
import TranslateField from 'components/common/fields/TranslateField';
import Input from 'components/common/form/Input';
import InputNumberSearch from 'components/common/form/InputNumberSearch';
import InputNumberMask from 'components/common/form/InputNumberMask';

import BaseFields from './fields/BaseFields';
import TypeFields from './fields/TypeFields';
import PositionFields from './fields/PositionFields';
import ApprovalFields from './fields/ApprovalFields';
import CopyFields from './fields/CopyFields';
import CellFields from './fields/CellFields';
import FieldSetters from './FieldSetters';

const withSetPosition = WrappedComponent => (
    class withSetPosition extends Component {
        setPosition = position => {
            const { change, batch } = this.props.form;

            batch(() => {
                change('position', position.position);
                change('positionEngl', position.positionEngl);
                change('responsibilities', position.responsibilities);
                change('requirements', position.requirements);

                change('positionCode', position.positionCode);
                change('positionCodeApproval', null);
                change('oldPositionId', position.positionCode);
                change('positionGradeCode', position.positionGradeCode);
                change('positionLevelCode', position.positionLevelCode);
                change('liabilityContractCode', position.liabilityContractCode);
                change('bonusSchemeCode', position.bonusSchemeCode);
                change('bonusSchemePercentCode', position.bonusSchemePercentCode);
                change('companyCarCode', position.companyCarCode);
                change('travellingWorkCode', position.travellingWorkCode);
                change('familyDMSCode', position.familyDMSCode);
                change('salaryLevel', position.salaryLevel);
                change('salaryLevelMid', position.salaryLevelMid);
                change('competences', position.competences && position.competences.map(item => ({
                    id: item.id,
                })));

                change('changePosition', null);
            });
        }

        render() {
            return <WrappedComponent
                {...this.props}
                setPosition={this.setPosition}
            />
        }
    }
);

@withSetPosition
@asyncConnect({
    getMetroPosition: getMetroPosition
        .withParams(() => ({ cnb: true }))
        .withSuccessHandler(({ setPosition }, { payload }) => {
            setPosition(payload);
        })
        .withOptions({ resetOnUnmount: true })
}, null, { openModalMetroRequestPosition })
export default class MetroRequestForm extends Component {
    clearBase = () => {
        const { change, batch } = this.props.form;

        batch(() => {
            change('department', null);
            change('departmentCode', null);

            change('region', null);
            change('city', null);
            change('store', null);
            change('storeCode', null);

            change('directorateCode', null);
            change('directorateEngl', null);
            change('directorateString', null);
            change('unitCode', null);
            change('unitEngl', null);
            change('unitString', null);
            change('divisionCode', null);
            change('divisionEngl', null);
            change('divisionString', null);

            change('requestType', null);
            change('function', null);
            change('positionCostCenters', null);

            change('chief', null);
            change('chiefCode', null);
            change('chiefPosition', null);
            change('chiefPositionCode', null);

            this.clearPositionFields();
        });
    }

    clearPosition = (requestType) => {
        if (requestType === METRO_REQUEST_NEW) {
            return;
        }

        const { batch, change } = this.props.form;

        batch(() => {
            this.clearPositionFields();

            change('occupationTypeCode', null);
            change('chartOfWorkCode', null);
            change('contractPeriod', null);
            change('mobilePhoneCode', null);
            change('responsibilities', null);
            change('requirements', null);
            change('accessToPCCode', null);
        });
    }

    clearPositionFields = () => {
        const { change } = this.props.form;

        change('displacedEmployee', null);
        change('displacedEmployeeCode', null);
        change('displacedEmployeePid', null);
        change('position', null);
        change('positionEngl', null);
        change('positionGradeCode', null);
        change('positionLevelCode', null);
        change('liabilityContractCode', null);
        change('bonusSchemeCode', null);
        change('bonusSchemePercentCode', null);
        change('companyCarCode', null);
        change('travellingWorkCode', null);
        change('familyDMSCode', null);
        change('salaryLevel', null);
        change('salaryLevelMid', null);
        change('competences', null);

        change('changePosition', null);
        change('cellId', null);
        change('positionCode', null);
        change('oldPositionId', null);
        change('positionCodeForRestore', null);
        change('positionCodeForCopy', null);
    }

    onPositionCodeApproval = (value, departmentCode, city, routeType) => {
        const positionCode = this.props.addDepartmentCode(value, departmentCode);
        this.props.form.change('positionCode', positionCode);
        this.props.form.change('positionCodeCNB', value);
        this.props.getMetroPosition.dispatch({ positionCode, city, routeType });
    }

    getChangeField = (name, pathData = ['label']) =>
        (_, data) => this.props.form.change(name, path(pathData, data))

    openModalRequestRouteEdit = () => {
        const { getMetroRequest: { data } } = this.props;

        this.props.openModalMetroRequestRoute({
            id: data.id,
            request: data,
            edit: true,
            callback: () => this.props.getMetroRequest.refresh()
        });
    }

    render() {
        const { postMetroRequestApproval: { meta : approvalMeta } } = this.props;
        if (approvalMeta.success) {
            return (
                <div className='card-form card-metro'>
                    <div className="card">
                        <div className="card-head">
                            <h3>
                                <Translate content='metro.request.title' component='span' />
                            </h3>
                        </div>
                        <div className="card-body">
                            <Translate content='metro.request.approved' component='span' />
                        </div>
                    </div>
                </div>
            );
        }

        const { formAction: { meta }, getMetroRequest: { data }, openModalMetroRequestPosition } = this.props;
        const { form, loading, match, user, approvalRole, authKey, getRoleConfig, dropMetroCode, setPosition } = this.props;
        const { showDocument, showCellIdField, showPositionIdField, showPositionIdFieldRequired, editPosition, editRoute, isACO, isCNB } = getRoleConfig();

        const draft = data.draft;
        const requestId = match.params.id;
        const created = !!requestId;
        const sended = created && (data.state !== METRO_REQUEST_DRAFT);
        const rejected = (user.id === data.initiatorCode) && (data.state === METRO_REQUEST_REJECTED);
        const approver = getApprover(data, user.id);
        const approvalEdit = sended && (approver.id && approver.id === user.id);
        const approvalRoute = data.approvalRoute;
        const isApproval = approvalEdit || approvalRole;
        const cellIdACO = data.cellId;
        const oldPosition = dropMetroCode(data.oldPositionId);

        return (
            <div className='card-form card-metro'>
                <div className="card">
                    <div className="card-head">
                        <h3>
                            <Translate content='metro.request.structure' component='span' />
                        </h3>
                    </div>

                    <div className="card-body">
                        <BaseFields
                            disabled={created || sended}
                            clearBase={this.clearBase}
                            clearPosition={this.clearPosition}
                            getChangeField={this.getChangeField}
                            {...this.props}
                        />

                        <ListenerField listenFieldName={[
                            'routeType',
                            'positionCode',
                            'positionCodeForRestore',
                            'positionCodeForCopy',
                            'departmentCode',
                            'cellId',
                            'city'
                        ]}>
                            { ({ routeType, positionCode, positionCodeForRestore, positionCodeForCopy, departmentCode, cellId, city }) => (
                                <div className={cx({ hide: !routeType || !departmentCode })}>
                                    { isCNB ? (
                                        <ApprovalFields
                                            departmentCode={departmentCode}
                                            positionCode={positionCode}
                                            cellId={cellId}
                                            oldPosition={oldPosition}
                                            isApproval={isApproval}
                                            isACO={isACO}
                                            isCNB={isCNB}
                                        />
                                    ) : (
                                        <TypeFields
                                            departmentCode={departmentCode}
                                            positionCode={positionCode}
                                            cellId={cellId}
                                            oldPosition={oldPosition}
                                            setPosition={setPosition}
                                            clearPosition={() => this.clearPosition()}
                                            clearCell={this.clearCell}
                                            getChangeField={this.getChangeField}
                                            {...this.props}
                                            disabled={sended}
                                            isCNB={isCNB}
                                            isACO={isACO}
                                            isApproval={isApproval}
                                        />
                                    )}
                                    <CopyFields
                                        positionCodeForRestore={positionCodeForRestore}
                                        positionCodeForCopy={positionCodeForCopy}
                                        positionCode={positionCode}
                                        oldPositionId={data.oldPositionId}
                                        getChangeField={this.getChangeField}
                                        clearPosition={() => this.clearPosition()}
                                        departmentCode={departmentCode}
                                        disabled={sended}
                                        isCNB={isCNB}
                                        isACO={isACO}
                                    />
                                    { isACO && !!cellIdACO && (
                                        <div>
                                            <div className="card-head-subhead">
                                                <h3>
                                                    <Translate content='metro.request.cellIdDescription' component='span' />
                                                </h3>
                                            </div>
                                            <div>
                                                <CellFields cell={cellIdACO} city={city} routeType={routeType} />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </ListenerField>
                    </div>

                    { !isApproval && !rejected && (
                        <FieldSetters
                            setPosition={setPosition}
                            setFunction={this.setFunction}
                            setPCC={this.setPCC}
                            setChief={this.setChief}
                            form={form}
                        />
                    )}

                    <ListenerField
                        listenFieldName={[
                            'changePosition',
                            'cellId',
                            'positionCode',
                            'positionCodeForCopy',
                            'positionCodeForRestore',
                            'routeType',
                            'requestType',
                            'region',
                            'city',
                            'directorateEngl',
                            'departmentCode',
                            'storeCode',
                            'displacedEmployee',
                        ]}
                    >
                        { ({
                            routeType,
                            requestType,
                            cellId,
                            positionCode,
                            positionCodeForCopy,
                            changePosition,
                            departmentCode,
                            storeCode,
                            city,
                            region,
                            directorateEngl,
                            displacedEmployee,
                        }) => {
                            const requestEditDisable = sended && !rejected;

                            const hide = (
                                !requestType
                                || requestType === METRO_REQUEST_CURRENT && !cellId
                            );

                            return (
                                <div className={cx({ hide })}>
                                    <div className="card-head">
                                        <h3>
                                            <span>
                                                <Translate content='metro.request.jobEvaluation' />
                                            </span>
                                        </h3>
                                    </div>
                                    <div className="card-body">
                                        { showCellIdField && (
                                            <Fragment>
                                                <Field
                                                    name='cellIdApproval'
                                                    component={InputNumberMask}
                                                    mask={CODE}
                                                    validate={required}
                                                    className='number-search disable-control'
                                                    label={{
                                                        content: (isACO || isCNB) ? 'metro.request.staffPosition' : 'metro.request.cellId',
                                                        required: true
                                                    }}
                                                />
                                                <Field
                                                    name='positionCodeCNB'
                                                    component={Input}
                                                    label={{ content: 'metro.request.positionId' }}
                                                    disabled={true}
                                                />
                                            </Fragment>
                                        )}
                                        { showPositionIdField && (
                                            <div>
                                                { editPosition && (
                                                    <Form.Item wrapperCol={wrapCellFormItem}>
                                                        <Translate content='placeholders.metroPositionCodeApproval' />
                                                    </Form.Item>
                                                )}
                                                <Field
                                                    name='positionCodeCNB'
                                                    component={InputNumberSearch}
                                                    mask={CODE}
                                                    label={{ content: 'metro.request.positionId', required: showPositionIdFieldRequired }}
                                                    disabled={!showPositionIdFieldRequired}
                                                    enterButton={editPosition ? translate('metro.request.searchCellId') : undefined}
                                                    validate={showPositionIdFieldRequired ? required : undefined}
                                                    onSearch={positionCode => {
                                                        openModalMetroRequestPosition({
                                                            positionCode,
                                                            onSubmit: ({ positionCodeApproval }) => {
                                                                this.onPositionCodeApproval(positionCodeApproval, departmentCode, city, routeType)
                                                            }
                                                        });
                                                    }}
                                                    withoutControls={editPosition}
                                                />
                                            </div>
                                        )}

                                        <PositionFields
                                            {...this.props}
                                            routeType={routeType}
                                            requestType={requestType}
                                            changePosition={changePosition}
                                            getChangeField={this.getChangeField}
                                            requestEditDisable={requestEditDisable}
                                            documents={data.documents}
                                            requestId={requestId}
                                            cellId={cellId}
                                            positionCodeForCopy={positionCodeForCopy}
                                            city={city}
                                            positionCode={positionCode}
                                            region={region}
                                            directorateEngl={directorateEngl}
                                            storeCode={storeCode}
                                            displacedEmployee={displacedEmployee}
                                            addDepartmentCode={value => this.props.addDepartmentCode(value, departmentCode)}

                                            isApproval={isApproval}
                                            isCNB={isCNB}
                                            approvalEdit={approvalEdit}
                                            showDocument={showDocument}
                                            editPosition={editPosition}
                                            setPosition={setPosition}

                                            saveDraftButton={showDocument ? (
                                                <FormSpy>
                                                    { ({ values, invalid }) => (
                                                        <Form.Item wrapperCol={wrapCellFormItem}>
                                                            <Button
                                                                onClick={() => this.props.sendForm(values, invalid, true)}
                                                                className="card-button"
                                                                disabled={loading || !(values.documentsUpload && values.documentsUpload.length)}
                                                            >
                                                                <Translate content='metro.request.documentAttach' />
                                                            </Button>
                                                        </Form.Item>
                                                    )}
                                                </FormSpy>
                                            ) : null}
                                            comments={(
                                                <Form.Item
                                                    labelCol={formItemLayout.labelCol}
                                                    wrapperCol={formItemLayout.wrapperCol}
                                                    label={<Translate content='metro.request.comments' component='span' />}
                                                >
                                                    { data.comments ? data.comments.map((comment, index) => (
                                                        <div className='text-pre-space' key={index}>
                                                            <b><TranslateField ru={comment.peopleName} en={comment.peopleNameEngl} /></b> &mdash; <span>{comment.comment}</span>
                                                        </div>
                                                    )) : <Translate content='metro.request.noComments' />}
                                                </Form.Item>
                                            )}
                                        />
                                    </div>
                                </div>
                            );
                        }}
                    </ListenerField>
                </div>

                { isApproval && (
                    <Form.Item
                        labelCol={formItemLayout.labelCol}
                        wrapperCol={formItemLayout.wrapperCol}
                        label={<Translate content='metro.request.initiatorName' component='span' />}
                    >
                        <div>{data.initiator}</div>
                    </Form.Item>
                )}

                { sended && (
                    <Form.Item
                        labelCol={formItemLayout.labelCol}
                        wrapperCol={formItemLayout.wrapperCol}
                        label={<Translate content='metro.approvalHistory' component='span' />}
                    >
                        { data.approvalHistory && data.approvalHistory.map((item, index) => item.approver ? (
                            <div className='text-pre-space' key={index}>
                                <b>
                                    {item.approver.name} {METRO_REQUEST_APPROVALS[item.role] ? (
                                        <Fragment>
                                            (<Translate content={`metro.request.approvals.${METRO_REQUEST_APPROVALS[item.role]}`} />)
                                        </Fragment>
                                    ) : null}
                                </b> &mdash; <i>{item.result}</i>
                                <p>{item.comment}</p>
                            </div>
                        ) : null)}
                    </Form.Item>
                )}

                { !draft && approvalRoute && (
                    <Fragment>
                            <Form.Item
                                labelCol={formItemLayout.labelCol}
                                wrapperCol={formItemLayout.wrapperCol}
                                label={<Translate content='metro.approvalRoute' component='span' />}
                            >
                                <div className='approval-route-view'>
                                    <ApprovalRouteList approvalRoute={approvalRoute} />
                                    { sended && editRoute && (
                                        <Button
                                            onClick={this.openModalRequestRouteEdit}
                                            className='approval-route-edit'
                                        >
                                            <Translate content="metro.editApprovalRoute" />
                                        </Button>
                                    )}
                                </div>
                            </Form.Item>
                    </Fragment>
                )}

                <Row className="card-bottom">
                    <Col xs={{ span: 12, offset: 5 }}>
                        <ErrorHTML className="card-error" meta={meta} />
                    </Col>
                </Row>

                <FormSpy>
                    { ({ values, invalid }) => !values.routeType && !created ? null : (
                        <Row className="card-bottom">
                            <Col className={cx({ invalid })} xs={{ span: 17, offset: 7 }}>
                                { values.draft ? (
                                    <Fragment>
                                        <Button
                                            onClick={() => this.props.sendForm(values, invalid, true)}
                                            className="card-button"
                                            disabled={loading || !values.departmentCode}
                                        >
                                            <Translate content='metro.saveDraft' />
                                        </Button>
                                        <Button
                                            type="primary"
                                            className="card-button"
                                            onClick={() => this.props.sendForm(values, invalid)}
                                            disabled={loading || !values.departmentCode}
                                        >
                                            <Translate content='metro.send' />
                                        </Button>
                                    </Fragment>
                                ) : rejected ? (
                                    <Button
                                        type="primary"
                                        className="card-button"
                                        onClick={() => this.props.sendForm(values, invalid)}
                                        disabled={loading}
                                    >
                                        { rejected ? (
                                            <Translate content='metro.send' />
                                        ) : (
                                            <Translate content='metro.save' />
                                        )}
                                    </Button>
                                ) : approvalEdit || approvalRole ? (
                                    <ApprovalButtons
                                        selected={data}
                                        disabled={loading}
                                        approve={() => {
                                            this.props.sendForm(values, invalid, false, true);
                                            if (!invalid) {
                                                this.props.openModalMetroRequestApprove([{
                                                    ...data,
                                                    authKey,
                                                }]);
                                            }
                                        }}
                                        reject={!approvalRole && (
                                            () => {
                                                this.props.sendForm(values, invalid, false, true);
                                                if (!invalid) {
                                                    this.props.openModalMetroRequestReject([{
                                                        ...data,
                                                        authKey,
                                                    }]);
                                                }
                                            }
                                        )}
                                    />
                                ) : null}
                            </Col>
                        </Row>
                    )}
                </FormSpy>
            </div>
        );
    }
}
